import React from 'react';
import { ConfigProvider } from 'antd';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * ProjectsTheme — the Projects pages take the Projects tile colour as their primary
 * (Nitish, Sep 11 2026: "Project gets its own color, and everything will be on that theme";
 * the Sep 4 ruling that a global app carries the SAME primary as its Employee Computer app,
 * the Routines precedent = Wake amber via routineShared.css).
 *
 * Projects is antd-driven (16 `type="primary"` buttons across 5 files, Tabs, the Create Project
 * modal), so the scope is a nested antd ConfigProvider rather than a CSS token pair: every
 * primary control under it, portaled modals included, takes brown at once. The parent theme
 * (algorithm, radii, the dark colorPrimary preservation) is inherited; only the primary pair
 * changes. Ink on the fill follows the app convention: white on the deep light accent, dark on
 * the light dark-face accent (ThemeContext colorTextLightSolid).
 *
 * Colours = AppIcon.js ICON_ACCENTS.brown (light #a87c4f / dark #d9b38c), the same pair the
 * Projects empty state already carries (--fx). The shared ContextTreeDocumentUpload stays teal
 * on the Organization page because that route is outside this scope.
 */
export const PROJECTS_ACCENT = { light: '#a87c4f', dark: '#d9b38c' };

const ProjectsTheme = ({ children }) => {
  const { isDarkMode } = useTheme();
  const accent = isDarkMode ? PROJECTS_ACCENT.dark : PROJECTS_ACCENT.light;
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: accent,
          colorTextLightSolid: isDarkMode ? '#1d1d1f' : '#ffffff',
        },
      }}
    >
      {/* --prj-accent lets the few hand-written CSS rules on these pages (chat icons) follow the same colour. */}
      <div className="prj-scope" style={{ '--prj-accent': accent, display: 'contents' }}>
        {children}
      </div>
    </ConfigProvider>
  );
};

export default ProjectsTheme;
